export { default as middleware } from "./middleware";
export { default as reducers } from "./reducers";



// WEBPACK FOOTER //
// ./client/react/Admin/store/index.js